"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDrawerTabConfiguration = void 0;
const uiState_1 = require("./uiState");
exports.defaultDrawerTabConfiguration = {
    [uiState_1.LeftEditorDrawerTabState.componentLibrary]: "left",
    [uiState_1.LeftEditorDrawerTabState.objects]: "left",
    [uiState_1.LeftEditorDrawerTabState.rules]: "left",
    [uiState_1.RightEditorDrawerTabState.inspectorNew]: "right",
    [uiState_1.RightEditorDrawerTabState.inspector]: "right",
    [uiState_1.RightEditorDrawerTabState.copilotChat]: "right",
    [uiState_1.RightEditorDrawerTabState.review]: "right",
    [uiState_1.RightEditorDrawerTabState.CLI]: "right",
    [uiState_1.RightEditorDrawerTabState.prompt]: "right",
    [uiState_1.RightEditorDrawerTabState.CAL]: "right",
};
//# sourceMappingURL=drawerTabConfiguration.js.map